<template>
    <div class="energy_balance">
        <div class="tree-wrap">
            <me-tree
                ref="myTree"
                :treeData="treeData"
                :treeLoading="treeLoading"
                :treeToolBar="false"
                :defaultProps="defaultProps"
                :nodeKey="'point_class_id'"
                :showCheckbox="true"
                title="类型"
                :checkStrictly.sync="checkStrictly"
                :isCheckClick="true"
                :isSingle="true"
                :showSearch="false"
                :defaultCheckKeys="defaultCheckKeys"
                @handleCheckBoxClick="handleTreeNodeClick"
            ></me-tree>
        </div>
        <div class="table-wrap">
            <div style="text-align: right;margin-bottom: 0.5rem;">
                <el-button class="leader-common-button" @click="addEdit('新增')"
                    >新增</el-button
                >
            </div>
            <el-scrollbar style="height: 85%">
                <el-table :data="tableData" class="leader-style-table">
                    <el-table-column width="100" align="center" label="序号">
                        <template slot-scope="scope">
                            <span>
                                {{
                                    (paginationData.pageNum - 1) *
                                        paginationData.pageSize +
                                        scope.$index +
                                        1
                                }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="point_loss_name"
                        label="损耗名称"
                    ></el-table-column>
                    <el-table-column
                        prop="remark"
                        label="备注"
                    ></el-table-column>
                    <el-table-column label="操作" width="200">
                        <template slot-scope="scope">
                            <el-button type="text" @click="lossClick(scope.row)"
                                >维护</el-button
                            >
                            <el-button
                                type="text"
                                @click="addEdit('修改', scope.row)"
                                >修改</el-button
                            >
                            <el-button type="text" @click="deleteRow(scope.row)"
                                >删除</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </el-scrollbar>
            <pagination
                class="leader-style-pagination"
                :paginationData="paginationData"
                @paginationDataNew="paginationDataNew"
            ></pagination>
        </div>
        <el-dialog
            :title="outTitle"
            :visible.sync="outVisible"
            width="50%"
            class="leader-dialog"
            @close="closeOutDialog"
        >
            <el-form
                :model="outForm"
                ref="outForm"
                label-width="100px"
                class="leader-style-form"
            >
                <el-form-item
                    label="损耗名称"
                    prop="point_loss_name"
                    :rules="[
                        {
                            required: true,
                            message: '请输入损耗名称',
                            trigger: 'blur'
                        }
                    ]"
                >
                    <el-input
                        v-model="outForm.point_loss_name"
                        maxlength="200"
                        placeholder="请输入损耗名称"
                    ></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input
                        type="textarea"
                        rows="3"
                        v-model="outForm.remark"
                        maxlength="500"
                        placeholder="请输入备注"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    size="small"
                    class="leader-common-button"
                    @click="closeOutDialog"
                    >取消</el-button
                >
                <el-button
                    size="small"
                    class="leader-common-button"
                    @click="outSave"
                    >保存</el-button
                >
            </div>
        </el-dialog>
        <el-dialog
            :title="treeDialogTitle"
            :visible.sync="treeVisible"
            width="40%"
            class="leader-dialog"
            @click="closeTreeDialog"
        >
            <div>
                <div style="display: flex">
                    <el-button
                        class="leader-common-button"
                        @click="innerAddEdit('新增')"
                        >新增</el-button
                    >
                    <el-button
                        class="leader-common-button"
                        @click="innerAddEdit('修改')"
                        >修改</el-button
                    >
                    <el-button class="leader-common-button" @click="innerDelete"
                        >删除</el-button
                    >
                </div>

                <me-tree
                    ref="myDialogTree"
                    :treeData="treeDialogData"
                    :treeToolBar="false"
                    :defaultProps="defaultDialogProps"
                    :nodeKey="'point_loss_dtl_id'"
                    :showCheckbox="true"
                    title="节点树"
                    :checkStrictly="true"
                    :isCheckClick="true"
                    :isSingle="true"
                    :treeHeight="'20rem'"
                    :defaultCheckKeys="defaultDialogCheckKeys"
                    :default-expanded-keys="defaultExpandedKeys"
                    @handleCheckBoxClick="handleDialogTreeNodeClick"
                ></me-tree>
            </div>
        </el-dialog>
        <el-dialog
            :title="innerTitle"
            :visible.sync="innerVisible"
            width="40%"
            class="leader-dialog"
            @click="closeInnerDialog"
        >
            <el-form
                :model="innerForm"
                ref="innerForm"
                label-width="100px"
                class="leader-style-form"
            >
                <el-form-item
                    label="名称"
                    prop="point_loss_dtl_name"
                    :rules="[
                        {
                            required: true,
                            message: '请输入名称',
                            trigger: 'blur'
                        }
                    ]"
                >
                    <el-input
                        v-model="innerForm.point_loss_dtl_name"
                        maxlength="200"
                        placeholder="请输入名称"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="采集点"
                    prop="point_id"
                    :rules="[
                        {
                            required: false,
                            message: '请输选择采集点',
                            trigger: 'blur'
                        }
                    ]"
                >
                    <tree-select
                        :list="treeListPower"
                        :obj="treeSelectDefault"
                        :multiple="false"
                        :clearable="true"
                        :checkStrictly="true"
                        v-model="innerForm.point_id"
                    ></tree-select>
                </el-form-item>
                <el-form-item
                    label="排序"
                    prop="seq"
                    :rules="[
                        {
                            required: true,
                            message: '请输入排序',
                            trigger: 'blur'
                        }
                    ]"
                >
                    <el-input
                        v-model="innerForm.seq"
                        maxlength="200"
                        placeholder="请输入排序"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    size="small"
                    class="leader-common-button"
                    @click="closeInnerDialog"
                    >取消</el-button
                >
                <el-button
                    size="small"
                    class="leader-common-button"
                    @click="innerSave"
                    >保存</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import pagination from "@/comon/components/pagination.vue";
import TreeSelect from "@/comon/components/tree-select.vue";
import * as api from "@/http/api.js";
export default {
    components: {
        "me-tree": Tree,
        pagination,
        TreeSelect
    },
    data() {
        return {
            treeData: [],
            treeLoading: false,
            defaultProps: {
                children: "childList",
                label: "class_name"
            },
            checkStrictly: true,
            defaultCheckKeys: [],
            selectPointClassId: "",
            tableData: [],
            paginationData: {
                pageNum: 1,
                pageSize: 10,
                totalNum: ""
            },
            outTitle: "",
            outVisible: false,
            outForm: {
                point_loss_id: "", //主键
                point_loss_name: "", //价格名称
                remark: "" //备注
            },
            treeDialogTitle: "",
            treeVisible: false,
            treeDialogData: [],
            defaultDialogProps: {
                children: "childList",
                label: "point_loss_dtl_name"
            },
            defaultDialogCheckKeys: [],
            defaultExpandedKeys: [],
            innerTitle: "新增",
            innerVisible: false,
            innerForm: {
                p_point_loss_dtl_id: "", // 父节点id
                point_loss_dtl_id: "", // 主键
                point_loss_id: "", // 主表id
                point_loss_dtl_name: "",
                point_id: "",
                seq: 0
            },
            treeListPower: [],
            treeSelectDefault: {
                id: "point_id",
                label: "point_name",
                pid: "p_point_id",
                children: "childList"
            },
            selectDialogTreeNode: {}
        };
    },
    mounted() {
        this.getPointLossClassList();
    },
    methods: {
        /**
         * @description: 左侧列表
         */
        getPointLossClassList() {
            api.getPointLossClassList().then(res => {
                if (res && res.error_code == 0) {
                    this.treeData = res.bus_json;
                    if (this.treeData.length > 0) {
                        this.defaultCheckKeys = [
                            this.treeData[0].point_class_id
                        ];
                        this.selectPointClassId = this.defaultCheckKeys[0];
                        this.getPointLossPage();
                    }
                }
            });
        },
        handleTreeNodeClick(select) {
            this.defaultCheckKeys = this.$refs.myTree.$refs.tree.getCheckedKeys();
            this.selectPointClassId = select.point_class_id;
            this.getPointLossPage();
        },

        /// 获取列表
        getPointLossPage() {
            api.getPointLossPage({
                pageNum: this.paginationData.pageNum,
                pageSize: this.paginationData.pageSize,
                point_class_id: this.selectPointClassId
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.tableData = res.bus_json.items;
                    this.paginationData.pageNum = res.bus_json.pageNum;
                    this.paginationData.pageSize = res.bus_json.pageSize;
                    this.paginationData.totalNum = res.bus_json.totalNum;
                }
            });
        },
        paginationDataNew(sth) {
            this.paginationData = sth;
        },
        // 新增 修改列表
        addEdit(title, row) {
            this.outTitle = title;
            this.outVisible = true;
            if (title == "修改") {
                this.outForm = { ...row };
            } else {
                this.outForm.point_loss_id = "";
                this.outForm.point_loss_name = "";
                this.outForm.remark = "";
            }
        },
        outSave() {
            this.$refs["outForm"].validate(valid => {
                if (valid) {
                    api.savePointLoss({
                        ...this.outForm,
                        point_class_id: this.selectPointClassId
                    }).then(res => {
                        if (res && res.error_code == 0) {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            this.closeOutDialog();
                            this.getPointLossPage();
                        }
                    });
                }
            });
        },
        // 删除
        deleteRow(row) {
            this.$confirm("确定删除这条数据吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(_ => {
                api.deletePointLoss({
                    point_loss_id: row.point_loss_id
                }).then(res => {
                    if (res && res.error_code === "0") {
                        // 最后一页，只有一条数据时，点击删除
                        if (
                            this.paginationData.totalNum -
                                (this.paginationData.pageNum - 1) *
                                    this.paginationData.pageSize ==
                            1
                        ) {
                            // 处理页码显示问题
                            this.paginationData.pageNum =
                                this.paginationData.pageNum == 1
                                    ? this.paginationData.pageNum
                                    : this.paginationData.pageNum - 1;
                        }
                        this.getPointLossPage();
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                    }
                });
            });
        },
        // 弹窗关闭
        closeOutDialog() {
            this.outVisible = false;
            this.$refs["outForm"].resetFields();
            this.$refs["outForm"].clearValidate();
        },
        // 维护
        lossClick(row) {
            this.treeDialogTitle = row.point_loss_name;
            this.treeVisible = true;
            this.innerForm.point_loss_id = row.point_loss_id;
            api.getPointLossDtlList({ point_loss_id: row.point_loss_id }).then(
                res => {
                    if (res && res.error_code == 0) {
                        this.treeDialogData = res.bus_json;
                    }
                }
            );
        },
        handleDialogTreeNodeClick(select) {
            this.defaultDialogCheckKeys = this.$refs.myDialogTree.$refs.tree.getCheckedKeys();
            console.log("select: ", select);
            this.selectDialogTreeNode = select;
        },
        innerAddEdit(title) {
            this.innerTitle = title;
            api.getCommonPointList({
                point_class_id: this.selectPointClassId
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.treeListPower = res.bus_json;
                    if (title == "新增") {
                        this.innerVisible = true;
                        this.innerForm.point_loss_dtl_name = "";
                        this.innerForm.point_id = "";
                        if (this.defaultDialogCheckKeys.length > 0) {
                            this.innerForm.p_point_loss_dtl_id = this.selectDialogTreeNode.point_loss_dtl_id;
                            this.innerForm.point_loss_dtl_id = "";
                        } else {
                            this.innerForm.p_point_loss_dtl_id = "";
                            this.innerForm.point_loss_dtl_id = "";
                        }
                    } else {
                        if (this.defaultDialogCheckKeys.length > 0) {
                            // 有选中
                            this.innerVisible = true;
                            this.innerForm.p_point_loss_dtl_id = this.selectDialogTreeNode.p_point_loss_dtl_id;
                            this.innerForm.point_loss_dtl_id = this.selectDialogTreeNode.point_loss_dtl_id;
                            this.innerForm.point_loss_dtl_name = this.selectDialogTreeNode.point_loss_dtl_name;
                            this.innerForm.point_id = this.selectDialogTreeNode.point_id;
                            this.innerForm.seq = this.selectDialogTreeNode.seq
                        } else {
                            // 无选中
                            this.$message({
                                message: "请先选择节点",
                                type: "warning"
                            });
                            return;
                        }
                    }
                }
            });
        },
        innerDelete() {
            if (this.defaultDialogCheckKeys.length == 0) {
                this.$message({
                    message: "请先选择节点",
                    type: "warning"
                });
                return;
            }
            this.$confirm("确定删除这条数据吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(_ => {
                api.deletePointLossDtl({
                    point_loss_dtl_id: this.selectDialogTreeNode
                        .point_loss_dtl_id
                }).then(res => {
                    if (res && res.error_code === "0") {
                        api.getPointLossDtlList({
                            point_loss_id: this.innerForm.point_loss_id
                        }).then(res => {
                            if (res && res.error_code == 0) {
                                this.treeDialogData = res.bus_json;
                            }
                        });
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                    }
                });
            });
        },
        innerSave() {
            this.$refs["innerForm"].validate(valid => {
                if (valid) {
                    api.savePointLossDtl({
                        ...this.innerForm
                    }).then(res => {
                        if (res && res.error_code == 0) {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            api.getPointLossDtlList({
                                point_loss_id: this.innerForm.point_loss_id
                            }).then(res => {
                                if (res && res.error_code == 0) {
                                    this.defaultExpandedKeys.push(res.bus_json[0].point_loss_dtl_id)
                                    this.defaultExpandedKeys.push(this.innerForm.point_loss_dtl_id)
                                    this.defaultExpandedKeys.push(this.innerForm.p_point_loss_dtl_id)
                                    this.treeDialogData = res.bus_json;
                                    
                                }
                            });
                            this.closeInnerDialog();
                        }
                    });
                }
            });
        },
        closeInnerDialog() {
            this.innerVisible = false;
            this.$refs["innerForm"].resetFields();
            this.$refs["innerForm"].clearValidate();
        }
    }
};
</script>
<style lang="scss">
.energy_balance {
    width: 100%;
    height: 100%;
    padding-right: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    .tree-wrap {
        z-index: 0;
        margin: 0 20px;
        width: 280px;
        height: 100%;
        overflow: hidden;
        box-sizing: border-box;
        border-radius: 5px;
    }
}
</style>
